import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useSelector } from 'react-redux';

import { ReliabilityHousesContainer } from './ReliabilityHousesContainer';
import { trackReliableBlockShow, trackReliableMoreClick } from './tracking';
import { Reliability } from '../../components/Reliability';
import { getNewbuildingId, isReliableSelector } from '../../selectors/newbuilding';

export function ReliabilityContainer() {
  const isReliable = useSelector(isReliableSelector);
  const newbuildingId = useSelector(getNewbuildingId);

  const onReliableMoreLinkClick = React.useCallback(() => {
    trackReliableMoreClick(newbuildingId);
  }, [newbuildingId]);

  const onReliableBlockShow = React.useCallback(() => {
    trackReliableBlockShow();
  }, []);

  /* istanbul ignore next */
  if (!isReliable) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={onReliableBlockShow} triggerOnce>
      <Reliability houses={<ReliabilityHousesContainer />} onReliableMoreLinkClick={onReliableMoreLinkClick} />
    </ActionAfterViewObserver>
  );
}
